module.exports = __webpack_public_path__ + "static/media/ZeitungMonoPro-Regular.de2eefcb.woff2";